import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function HonoraryFlagLead() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="rounded-md border border-primary/20 bg-primary/10 mt-2 mb-4 p-4 flex items-center gap-3 relative">
      <span className="font-light text-lg text-muted-foreground">
        <i>{t('dashboard.leadText', 'Your feedback directly shapes Monomo Enterprise')}</i>
      </span>
      <button
        type="button"
        aria-label={t('dashboard.closeLeadText', 'Hide')}
        className="absolute top-2 right-2 p-1 text-muted-foreground hover:text-muted-foreground transition"
        onClick={() => setVisible(false)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="size-4" fill="none" viewBox="0 0 20 20" stroke="currentColor">
          <path strokeLinecap="round" strokeWidth="2" d="M6 6l8 8m0-8l-8 8" />
        </svg>
      </button>
    </div>
  );
}
